export default __webpack_public_path__ + "static/media/10.e0d97801.webp";